// --- PRIORITY MODULES ---

// Import ServiceWorker file
// import '../webworker/serviceWorker';

// V5 only needs the shared matchMedia compatibility patch.
// AbortController is expected to be provided natively.
import '@shared/polyfills/match-media-event-listener.js';
// Lazysizes
import '@shared/modules/lazysizes.js';
// Global
// import 'jquery';

// --- END-PRIORITY MODULES ---

import { bootstrapV5 } from './bootstrap.js';

void bootstrapV5();
